// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Category } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { icon1: Category };

// ==============================|| MENU ITEMS - stream ||============================== //

const Division: NavItemType = {
  id: 'group-division',
  type: 'group',
  icon: icons.icon1,
  name: 'Division',
  children: [
    {
      icon: icons.icon1,
      id: 'Division',
      title: <FormattedMessage id="Division" />,
      type: 'item',
      url: '/Division'
    }
  ]
};

export default Division;